/**
 * CANVAS
 */

import CanvasLine from "./CanvasLine";
import CanvasRectangle from "./CanvasRectangle";
import CanvasCircle from "./CanvasCircle";

export default {
  polygon: CanvasLine, 
  rectangle: CanvasRectangle, 
  circle: CanvasCircle,
};

/**
 * FIN CANVAS
 */

